import image_2 from 'asset/use_cases_1.png';
import image_1 from 'asset/use_cases_2.png';

export const data_use_cases = {
  prefix: 'Use cases',
  title: 'XR Design Pro <br/> for the Entire Value Chain',
  items: [
    {
      id: 1,
      image: image_1,
      title: 'Custom Car Design',
      description: `Put your customers in the driver’s seat with XR car design, an immersive, real-time XR experience. Interact every detail of your custom car design with immersive features like real car seating, intuitive controls for exploration, and real-time collaboration. Customize colors, configurations, and view your finished model from every angle to bring your vision to life. <br/><br/> A high-fidelity virtual experience of custom automobiles makes them nearly indistinguishable from reality. With advanced AI, it enables seamless customization and real-time collaboration in a dynamic 3D simulation. Take a seat and watch your dream car come to life in stunning detail.`,
    },
    {
      id: 2,
      image: image_2,
      title: 'Production line design and configuration',
      description: `Bring the digital twins of your production line to life with XR. Test various machinery configurations <a href="https://simulationfirst.softserveinc.com" target="_blank">simulation-first</a> in a lifelike virtual environment before deploying them in real-world settings. Interact with life-sized versions of physical assets and use your expertise to determine the optimal pattern.<br/><br/>Find inefficiencies or detect potential safety hazards and immediately pause or resume actions with user-friendly UI buttons. This not only enhances operational efficiency but also significantly improves worker safety. Shape your industry's future with XR Design Pro's virtual reality technology.`,
    },
  ],
};
